import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-hot-toast";
import { ApiService } from "services";
import DashboardLayout from "layouts/DashboardLayout";
import { FormInput } from "components";

export default function BalanceConfiguration() {
  const [balanceConfig, setBalanceConfig] = useState();
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [balanceConfigModal, setBalanceConfigModal] = useState(false);
  const [editingConfigIndex, setEditingConfigIndex] = useState(null);
  const [balanceConfigData, setBalanceConfigData] = useState({
    organisationId: "",
    accountNumber: "",
    balanceApiEnabled: true,
    balanceApiUrl: "",
  });
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [configToDelete, setConfigToDelete] = useState(null);

  const resetForm = () => {
    setBalanceConfigData({
      organisationId: "",
      accountNumber: "",
      balanceApiEnabled: true,
      balanceApiUrl: "",
    });
    setEditingConfigIndex(null);
  };

  const getBalanceConfig = async () => {
    setLoadingConfig(true);
    try {
      const data = await ApiService.getBalanceConfig();
      setLoadingConfig(false);
      setBalanceConfig(data?.data);
    } catch (err) {
      setLoadingConfig(false);
      toast.error(err?.response?.data?.message || err?.message);
    }
  };

  const configureBalance = async (data) => {
    setLoadingBalance(true);
    try {
      if (editingConfigIndex !== null) {
        // Update existing configuration
        await ApiService.updateBalanceConfiguration(editingConfigIndex, data);
      } else {
        // Create new configuration
        await ApiService.createBalanceConfiguration(data);
      }
      setLoadingBalance(false);
      toast.success(
        editingConfigIndex !== null
          ? "Balance configuration updated successfully!"
          : "Balance configuration created successfully!"
      );
      setBalanceConfigModal(false);
      resetForm();
      getBalanceConfig();
    } catch (err) {
      setLoadingBalance(false);
      toast.error(err?.response?.data?.message || err?.message);
    }
  };

  const openDeleteModal = (config) => {
    setConfigToDelete(config);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    setConfigToDelete(null);
  };

  const deleteBalanceConfiguration = async (data) => {
    setLoadingBalance(true);
    try {
      await ApiService.deleteBalanceConfiguration(data);
      setLoadingBalance(false);
      toast.success("Balance configuration deleted successfully!");
      setBalanceConfigModal(false);
      closeDeleteModal();
      resetForm();
      getBalanceConfig();
    } catch (err) {
      setLoadingBalance(false);
      toast.error(err?.response?.data?.message || err?.message);
    }
  };

  const handleBalanceConfigSubmit = () => {
    if (
      !balanceConfigData.organisationId ||
      !balanceConfigData.accountNumber ||
      !balanceConfigData.balanceApiUrl
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    const configData =
      editingConfigIndex !== null
        ? { ...balanceConfigData, configIndex: editingConfigIndex }
        : balanceConfigData;

    configureBalance({
      organisationId: configData.organisationId,
      accountNumber: configData.accountNumber,
      balanceApiEnabled: configData.balanceApiEnabled,
      balanceApiUrl: configData.balanceApiUrl,
    });
  };

  useEffect(() => {
    getBalanceConfig();
  }, []);

  return (
    <DashboardLayout>
      <div style={{ padding: "20px" }}>
        <div style={{ marginBottom: "30px" }}>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "600",
              color: "#333",
              margin: 0,
            }}
          >
            Balance Configuration
          </h1>
          <p style={{ fontSize: "16px", color: "#666", margin: "8px 0 0 0" }}>
            Manage balance enquiry settings and API configurations for all
            institutions
          </p>
        </div>

        {/* Balance Configuration Section */}
        <Terminal style={{ background: "#DFDFF6" }}>
          <div style={{ width: "100%" }}>
            {/* Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "24px",
                paddingBottom: "16px",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </div>
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Balance Configuration
                  </h3>
                  <p
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    API settings and account configuration for all institutions
                  </p>
                </div>
              </div>

              <button
                onClick={() => {
                  resetForm();
                  setBalanceConfigModal(true);
                }}
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.3s ease",
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4v16m8-8H4"
                    stroke="white"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
                Configure Balance
              </button>
            </div>

            {/* Configuration Display */}
            {balanceConfig ? (
              <div>
                {/* Show Multiple Configurations */}
                {Array.isArray(balanceConfig) && balanceConfig.length > 0 && (
                  <div
                    style={{
                      background: "white",
                      borderRadius: "12px",
                      padding: "20px",
                      border: "1px solid #E8E8E8",
                      marginBottom: "24px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                          stroke="#9C27B0"
                          strokeWidth="2"
                          fill="none"
                        />
                        <circle
                          cx="9"
                          cy="7"
                          r="4"
                          stroke="#9C27B0"
                          strokeWidth="2"
                          fill="none"
                        />
                        <path
                          d="M23 21v-2a4 4 0 00-3-3.87"
                          stroke="#9C27B0"
                          strokeWidth="2"
                          fill="none"
                        />
                        <path
                          d="M16 3.13a4 4 0 010 7.75"
                          stroke="#9C27B0"
                          strokeWidth="2"
                          fill="none"
                        />
                      </svg>
                      <h4
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        All Institution Configurations ({balanceConfig.length})
                      </h4>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "16px",
                      }}
                    >
                      {balanceConfig.map((config, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "20px",
                            background: "#F8F9FA",
                            borderRadius: "12px",
                            border: "1px solid #E9ECEF",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onClick={() => {
                            // Set the selected configuration for editing
                            setBalanceConfigData({
                              organisationId: config.organisation.id || "",
                              accountNumber: config.accountNumber || "",
                              balanceApiEnabled:
                                config.balanceApiEnabled || true,
                              balanceApiUrl: config.balanceApiUrl || "",
                            });
                            setBalanceConfigModal(true);
                            setEditingConfigIndex(config.organisation.id);
                          }}
                        >
                          {/* Institution Header */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              marginBottom: "16px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "8px",
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              {config.organisation?.name?.charAt(0) || "I"}
                            </div>
                            <div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  color: "#333",
                                  marginBottom: "2px",
                                }}
                              >
                                {config.organisation?.name ||
                                  "Unknown Institution"}
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                }}
                              >
                                Code: {config.organisation?.code || "N/A"}
                              </div>
                            </div>
                          </div>

                          {/* Configuration Details */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  fontWeight: "500",
                                }}
                              >
                                Account Number:
                              </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#333",
                                  fontWeight: "600",
                                  fontFamily: "monospace",
                                }}
                              >
                                {config.accountNumber || "N/A"}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  fontWeight: "500",
                                }}
                              >
                                API Status:
                              </span>
                              <span
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  padding: "2px 6px",
                                  borderRadius: "8px",
                                  background: config.balanceApiEnabled
                                    ? "#E8F5E8"
                                    : "#FFEBEE",
                                  color: config.balanceApiEnabled
                                    ? "#2E7D32"
                                    : "#C62828",
                                }}
                              >
                                {config.balanceApiEnabled
                                  ? "Enabled"
                                  : "Disabled"}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  fontWeight: "500",
                                }}
                              >
                                Domain:
                              </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#333",
                                  fontWeight: "600",
                                }}
                              >
                                {config.organisation?.domain || "N/A"}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  fontWeight: "500",
                                }}
                              >
                                Type:
                              </span>
                              <span
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  padding: "2px 6px",
                                  borderRadius: "8px",
                                  background: "#E3F2FD",
                                  color: "#1976D2",
                                  textTransform: "capitalize",
                                }}
                              >
                                {config.organisation?.institutionType || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div
                            style={{
                              marginTop: "16px",
                              display: "flex",
                              gap: "8px",
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                padding: "8px 12px",
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                borderRadius: "8px",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                // Set the selected configuration for editing
                                setBalanceConfigData({
                                  organisationId: config.organisation.id || "",
                                  accountNumber: config.accountNumber || "",
                                  balanceApiEnabled:
                                    config.balanceApiEnabled || true,
                                  balanceApiUrl: config.balanceApiUrl || "",
                                });
                                setBalanceConfigModal(true);
                                setEditingConfigIndex(config.organisation.id);
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "white",
                                  fontWeight: "600",
                                }}
                              >
                                Edit
                              </span>
                            </div>
                            <div
                              style={{
                                padding: "8px 12px",
                                background: "#dc3545",
                                borderRadius: "8px",
                                textAlign: "center",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = "#c82333";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = "#dc3545";
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(config);
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "white",
                                  fontWeight: "600",
                                }}
                              >
                                Delete
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Single Configuration Display (if not array) */}
                {!Array.isArray(balanceConfig) && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(300px, 1fr))",
                      gap: "24px",
                    }}
                  >
                    {/* Account Configuration */}
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "20px",
                        border: "1px solid #E8E8E8",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                              stroke="#4CAF50"
                              strokeWidth="2"
                              fill="none"
                            />
                          </svg>
                          <h4
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#333",
                            }}
                          >
                            Account Details
                          </h4>
                        </div>
                        <button
                          onClick={() => {
                            openDeleteModal(balanceConfig);
                          }}
                          style={{
                            padding: "8px 16px",
                            background: "#dc3545",
                            border: "none",
                            borderRadius: "6px",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#c82333";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "#dc3545";
                          }}
                        >
                          Delete
                        </button>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              fontWeight: "500",
                            }}
                          >
                            Account Number:
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#333",
                              fontWeight: "600",
                              fontFamily: "monospace",
                            }}
                          >
                            {balanceConfig?.accountNumber || "N/A"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              fontWeight: "500",
                            }}
                          >
                            Organisation:
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#333",
                              fontWeight: "600",
                            }}
                          >
                            {balanceConfig?.organisation?.name || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* API Configuration */}
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "20px",
                        border: "1px solid #E8E8E8",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
                              stroke="#2196F3"
                              strokeWidth="2"
                              fill="none"
                            />
                            <path
                              d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
                              stroke="#2196F3"
                              strokeWidth="2"
                              fill="none"
                            />
                          </svg>
                          <h4
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#333",
                            }}
                          >
                            API Configuration
                          </h4>
                        </div>
                        <button
                          onClick={() => {
                            openDeleteModal(balanceConfig);
                          }}
                          style={{
                            padding: "8px 16px",
                            background: "#dc3545",
                            border: "none",
                            borderRadius: "6px",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#c82333";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "#dc3545";
                          }}
                        >
                          Delete
                        </button>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              fontWeight: "500",
                            }}
                          >
                            API Status:
                          </span>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              background: balanceConfig?.balanceApiEnabled
                                ? "#E8F5E8"
                                : "#FFEBEE",
                              color: balanceConfig?.balanceApiEnabled
                                ? "#2E7D32"
                                : "#C62828",
                            }}
                          >
                            {balanceConfig?.balanceApiEnabled
                              ? "Enabled"
                              : "Disabled"}
                          </span>
                        </div>

                        <div style={{ marginTop: "8px" }}>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              fontWeight: "500",
                              marginBottom: "8px",
                            }}
                          >
                            API URL:
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#333",
                              background: "#F8F9FA",
                              padding: "12px",
                              borderRadius: "8px",
                              border: "1px solid #E9ECEF",
                              wordBreak: "break-all",
                              fontFamily: "monospace",
                            }}
                          >
                            {balanceConfig?.balanceApiUrl ||
                              "No URL configured"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "60px 20px",
                  color: "#666",
                  textAlign: "center",
                }}
              >
                <div>
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginBottom: "16px", opacity: 0.5 }}
                  >
                    <path
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      stroke="#666"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "8px",
                    }}
                  >
                    No Configuration Found
                  </div>
                  <div style={{ fontSize: "14px", color: "#888" }}>
                    Click the "Configure Balance" button to set up your balance
                    API configuration
                  </div>
                </div>
              </div>
            )}

            {/* Loading State */}
            {loadingConfig && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "40px",
                  color: "#666",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "2px solid #E0E0E0",
                    borderTop: "2px solid #14A2FD",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    marginRight: "12px",
                  }}
                />
                Loading configuration data...
              </div>
            )}
          </div>
        </Terminal>

        {/* Balance Configuration Modal */}
        {balanceConfigModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={() => {
              setBalanceConfigModal(false);
              resetForm();
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "30px",
                width: "500px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                overflow: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h2 style={{ margin: 0, color: "#333" }}>
                  {editingConfigIndex !== null
                    ? `Edit ${Array.isArray(balanceConfig)
                      ? balanceConfig.find(
                        (config) => config.id === editingConfigIndex
                      )?.organisation?.name || "Institution"
                      : balanceConfig?.organisation?.name || "Institution"
                    }`
                    : "Balance Configuration"}
                </h2>
                <button
                  onClick={() => {
                    setBalanceConfigModal(false);
                    resetForm();
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "#666",
                  }}
                >
                  ×
                </button>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <FormInput
                  label="Account Number *"
                  placeholder="Enter account number"
                  value={balanceConfigData.accountNumber}
                  onChange={(e) =>
                    setBalanceConfigData({
                      ...balanceConfigData,
                      accountNumber: e.target.value,
                    })
                  }
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <FormInput
                  label="Balance API URL *"
                  placeholder="https://api.example.com/balance-enquiry"
                  value={balanceConfigData.balanceApiUrl}
                  onChange={(e) =>
                    setBalanceConfigData({
                      ...balanceConfigData,
                      balanceApiUrl: e.target.value,
                    })
                  }
                />
              </div>

              {editingConfigIndex !== null
                ? ""
                : Array.isArray(balanceConfig) && (
                  <div style={{ marginBottom: "20px" }}>
                    <FormInput
                      label="Organisation ID *"
                      placeholder="Enter organisation ID"
                      value={balanceConfigData.organisationId}
                      onChange={(e) =>
                        setBalanceConfigData({
                          ...balanceConfigData,
                          organisationId: e.target.value,
                        })
                      }
                    />
                  </div>
                )}

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    color: "#333",
                  }}
                >
                  Balance API Enabled
                </label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="checkbox"
                    checked={balanceConfigData.balanceApiEnabled}
                    onChange={(e) =>
                      setBalanceConfigData({
                        ...balanceConfigData,
                        balanceApiEnabled: e.target.checked,
                      })
                    }
                    style={{ width: "18px", height: "18px" }}
                  />
                  <span style={{ color: "#666" }}>
                    Enable balance enquiry API
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  marginTop: "30px",
                }}
              >
                {/* Delete button - only show when editing */}
                {editingConfigIndex !== null && (
                  <button
                    onClick={() => {
                      openDeleteModal({ id: editingConfigIndex });
                    }}
                    style={{
                      padding: "12px 24px",
                      border: "none",
                      borderRadius: "8px",
                      background: "#dc3545",
                      cursor: "pointer",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#c82333";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "#dc3545";
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                    Delete
                  </button>
                )}

                {/* Right side buttons */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <button
                    onClick={() => {
                      setBalanceConfigModal(false);
                      resetForm();
                    }}
                    style={{
                      padding: "12px 24px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      background: "white",
                      cursor: "pointer",
                      color: "#666",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleBalanceConfigSubmit}
                    disabled={loadingBalance}
                    style={{
                      padding: "12px 24px",
                      border: "none",
                      borderRadius: "8px",
                      background: loadingBalance ? "#ccc" : "#14A2FD",
                      cursor: loadingBalance ? "not-allowed" : "pointer",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {loadingBalance ? (
                      <>
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "2px solid #fff",
                            borderTop: "2px solid transparent",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        />
                        {editingConfigIndex !== null
                          ? "Updating..."
                          : "Configuring..."}
                      </>
                    ) : editingConfigIndex !== null ? (
                      "Update Balance"
                    ) : (
                      "Configure Balance"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={closeDeleteModal}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "30px",
                width: "400px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                overflow: "auto",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    background: "#FEE2E2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                      stroke="#DC2626"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </div>
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "#1F2937",
                    }}
                  >
                    Delete Configuration
                  </h3>
                  <p
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: "14px",
                      color: "#6B7280",
                    }}
                  >
                    This action cannot be undone
                  </p>
                </div>
              </div>

              <p
                style={{
                  margin: "0 0 24px 0",
                  fontSize: "16px",
                  color: "#374151",
                  lineHeight: "1.5",
                }}
              >
                Are you sure you want to delete the balance configuration for{" "}
                <strong>
                  {configToDelete?.organisation?.name ||
                    configToDelete?.organisationId ||
                    "this institution"}
                </strong>
                ? This will permanently remove all associated settings.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  onClick={closeDeleteModal}
                  style={{
                    padding: "12px 20px",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    background: "white",
                    cursor: "pointer",
                    color: "#374151",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = "#9CA3AF";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = "#D1D5DB";
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    deleteBalanceConfiguration(configToDelete.id);
                  }}
                  disabled={loadingBalance}
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "8px",
                    background: loadingBalance ? "#FCA5A5" : "#DC2626",
                    cursor: loadingBalance ? "not-allowed" : "pointer",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!loadingBalance) {
                      e.target.style.background = "#B91C1C";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loadingBalance) {
                      e.target.style.background = "#DC2626";
                    }
                  }}
                >
                  {loadingBalance ? (
                    <>
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          border: "2px solid #fff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          marginRight: "8px",
                        }}
                      />
                      Deleting...
                    </>
                  ) : (
                    "Delete Configuration"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

const Terminal = styled.div`
  position: relative;
  background-color: white;
  border-radius: 10px;
  padding: 26px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

// Add CSS for loading animation
const style = document.createElement("style");
style.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);
